<template>
  <IconButton :to="url" class="button-secondary button-full" icon="google" v-on="$listeners">
    <slot>Log In with Google</slot>
  </IconButton>
</template>

<script>
export default {
  name: 'GoogleLoginButton',
  computed: {
    url() {
      return new URL('/auth/google', process.env.VUE_APP_API_BASE_URL);
    },
  },
};
</script>
